import { FormValidators } from '@servicetitan/form';
import { UserPhone } from '../api/account-settings.api';
import { UserPhoneConfig } from '../constants/user-phone-config';

export const phoneNumberRequiredValidator = (value: UserPhone) => {
    return FormValidators.required(value.phone) && 'Mobile phone number is required.';
};

export const phoneNumberPatternValidator = (value: UserPhone) => {
    if (!value.phone) {
        return undefined;
    }
    const regexp = UserPhoneConfig[value.countryCode].regexp;
    return FormValidators.isMatchingRegex(regexp, 'Phone Number')(value.phone);
};
